import { external as externalScript } from '../../utils/script'
import { getSite, getIsPostPage, postTemplate } from '../../application/pageDataObject'

function loadPPTrackerScript() {
  externalScript.load({
    name: 'pptracker',
    loadNow: true,
  })
}

export default function initPPTracker() {
  if (getIsPostPage()) {
    if (postTemplate === 'slideshow') {
      if ('90min' === getSite() || '12up' === getSite()) {
        loadPPTrackerScript()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initPPTracker.js